import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

  @Input() text: string;

  constructor(
    private translator: TranslateService
  ) {
    setTimeout(() => {
      this.text = this.translator.instant('Si la page est trop longue à charger, rafraichissez-la !');
    }, 8000);
  }

  ngOnInit() {
  }

}
